import type { CaptureMode } from '../types';

/**
 * Parse the `mode` query param. Unknown/absent values fall back to 'verify' —
 * the param drives labelling only; capture behavior is identical either way.
 */
export function parseCaptureMode(search: string): CaptureMode {
  return new URLSearchParams(search).get('mode') === 'enroll' ? 'enroll' : 'verify';
}
